import React from 'react';
import './styles.css';

interface Props {
  icon?: any;
  iconSymbol?: string;
  title: string;
  subtitle?: string;
}

const PageTitle = React.memo(({icon, title, subtitle, iconSymbol}: Props) => {
  return (
    <div>
      <div className="PageTitleContainer">
        {icon && <img src={icon} alt="icon" />}
        {iconSymbol && <span className={iconSymbol}></span>}
        <h1>{title}</h1>
      </div>
      {subtitle && (
        <h5
          className={
            icon ? 'PageTitleSubtitle' : 'PageTitleSubtitleWithoutIcon'
          }>
          {subtitle}
        </h5>
      )}
    </div>
  );
});

export default PageTitle;
